<app-view-pharmacy-component />